import { useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import useUserData from "./hooks/useUserData";
import CustomAccordion from "./components/CustomAccordion";
import ShiftAccordion from "./components/ShiftAccordion";
import AcademicAndWorkInfo from "./components/AcademicAndWorkInfo";
import OtherInformation from "./components/OtherInformation";
import HeaderCard from "./components/HeaderCard";

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

import { Button } from '@libComponents';
import MyChangeRequests from 'profileChangeRequests/components/MyChangeRequests';

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 1, pt: 3, pb: 3,  }}>{children}</Box>}
        </div>
    );
}

function Profile() {
    const [expandedTab1, setExpandedTab1] = useState(false);
    const [expandedTab2, setExpandedTab2] = useState(false);

    const [value, setValue] = useState(0);

    // Self view (own profile) → the employee can request changes to their
    // general information and see their request history.
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const email = searchParams.get('id');
    const isSelf = searchParams.get('isSelf') === 'true';

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleAccordionChangeTab1 = (panel) => (event, isExpanded) => {
        setExpandedTab1(isExpanded ? panel : false);
    };

    const handleAccordionChangeTab2 = (panel) => (event, isExpanded) => {
        setExpandedTab2(isExpanded ? panel : false);
    };

    const { dataGeneralInfo, dataContactInfo, dataFamilyInfo, dataIdentificationInfo, dataAcademicInfo, dataOtherInfo, shiftData } = useUserData();


    if (!dataGeneralInfo || !dataContactInfo || !dataFamilyInfo || !dataIdentificationInfo || !dataAcademicInfo || !dataOtherInfo || !shiftData) return null;

    return (
        <div>
            <HeaderCard
                dataInfo={dataGeneralInfo}
                dataIdentificationInfo={dataIdentificationInfo}
            />
            <Box sx={{ width: '100%' }}>
                <Box
                    sx={{
                        borderBottom: 1,
                        borderColor: 'divider',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 2
                    }}
                >
                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                        <Tab label="User Information" id="simple-tab-0" aria-controls="simple-tabpanel-0" />
                        <Tab label="Managerial Information" id="simple-tab-1" aria-controls="simple-tabpanel-1" />
                        {isSelf && (
                            <Tab label="Change Requests" id="simple-tab-2" aria-controls="simple-tabpanel-2" />
                        )}
                    </Tabs>
                    {isSelf && (
                        <Button
                            size='small'
                            sx={{ whiteSpace: 'nowrap', mr: 1 }}
                            onClick={() =>
                                navigate(
                                    `/profile-change-request?id=${email}&isSelf=true`
                                )
                            }
                        >
                            Request a Change
                        </Button>
                    )}
                </Box>
                <CustomTabPanel value={value} index={0}>
                    <>
                        <CustomAccordion
                            expanded={expandedTab1}
                            onChange={handleAccordionChangeTab1}
                            panelId="panel1"
                            title="General Information"
                            dataInfo={dataGeneralInfo}
                        />
                        <CustomAccordion
                            expanded={expandedTab1}
                            onChange={handleAccordionChangeTab1}
                            panelId="panel2"
                            title="Contact Information"
                            dataInfo={dataContactInfo}
                        />
                        <CustomAccordion
                            expanded={expandedTab1}
                            onChange={handleAccordionChangeTab1}
                            panelId="panel3"
                            title="Family Information"
                            dataInfo={dataFamilyInfo}
                        />
                        <CustomAccordion
                            expanded={expandedTab1}
                            onChange={handleAccordionChangeTab1}
                            panelId="panel4"
                            title="Identification Information"
                            dataInfo={dataIdentificationInfo}
                        />
                        <AcademicAndWorkInfo
                            expanded={expandedTab1}
                            onChange={handleAccordionChangeTab1}
                            panelId="panel5"
                            title="Academic Information & Work Experiences"
                            dataInfo={dataAcademicInfo}
                        />
                        <OtherInformation
                            expanded={expandedTab1}
                            onChange={handleAccordionChangeTab1}
                            panelId="panel6"
                            title="Other Information"
                            dataInfo={dataOtherInfo}
                        />
                    </>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                    <>
                        <ShiftAccordion
                            expanded={expandedTab2}
                            onChange={handleAccordionChangeTab2}
                            panelId="panel1"
                            title="Shift Information"
                            dataInfo={shiftData}
                        />
                    </>
                </CustomTabPanel>
                {isSelf && (
                    <CustomTabPanel value={value} index={2}>
                        <MyChangeRequests />
                    </CustomTabPanel>
                )}
            </Box>
        </div>
    )
}

export default Profile
